export const isArray = (val: unknown): val is unknown[] => Array.isArray(val);
